import React from "react";
import {useFeatureFlags} from "../../context/FeatureFlagProvider";
import {SidebarOld} from "./SidebarOld";
import {SidebarNew} from "./SidebarNew";

export const Sidebar = () => {
  const {newSidebarDesign} = useFeatureFlags();
  return newSidebarDesign ? <SidebarNew /> : <SidebarOld />;
};
